import { sidebarToggle, logoutAdmin } from "../../store/actions";
import { deleteCookie } from "../Common";
import { useDispatch } from "react-redux";
import {
  Box,
  AppBar,
  IconButton,
  Button,
  Typography,
  Toolbar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

export default function AdminPanelHeader() {
  const dispatch = useDispatch();
  const logoutFn = () => {
    dispatch(logoutAdmin());
    deleteCookie("admin_active");
  };

  return (
    <Box>
      <AppBar
        position="fixed"
        sx={{ backgroundColor: "#ec004f", boxShadow: 1 }}
      >
        <Toolbar sx={{ height: "65px" }}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={() => dispatch(sidebarToggle())}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Biddify
          </Typography>
          <Button sx={{ color: "#fff" }} onClick={() => logoutFn()}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
